import '@/config'
import axios from 'axios'
import store from '@/store'
import router from '../router'

import codes from '@/utils/returnCode'
import message from '@/utils/message'
// 创建axios实例
const service = axios.create({
  baseURL: _APIURL_, // api的base_url
  timeout: 30000 // 请求超时时间
})

let toast;
// request拦截器
service.interceptors.request.use(config => {
  if (store.state.token) {
    config.headers.Authorization ="Bearer "+store.state.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  toast=message.toast("",15000)
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    const resp = response.data
    if (resp.code!==codes.success) {//只有是200的请求才能正确通过
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (resp.code ===codes.Unauthorized ) {
        message.toast("您被登出系统",1000,()=>{
           router.push({name:'login'})
        })
      }
      else{
         toast.hide();
         message.popup(resp.msg);
      }
      return Promise.reject('error')
    } else {
      toast.hide();
      return response.data
    }
  },
  error => {
    message.popup(error);
    return Promise.reject(error)
  }
)
export default service
